<div class="row">
  <div
    *ngIf="!controlIsDisabled('CheckingAccountStatus')"
    [ngClass]="['col-12', !split ? 'col-lg-10' : 'col-md-6 col-lg-4']"
  >
    <div>
      <label class="form-label">
        Do you have an open checking account in good standing?
        <span
          *ngIf="controlIsRequired('CheckingAccountStatus')"
          class="color-error"
          >*</span
        >
      </label>
    </div>
    <div
      class="form-check-inline mb-3"
      *ngFor="let item of checkingAccountStatus; index as i"
    >
      <div class="form-check">
        <input
          class="form-check-input"
          type="radio"
          [value]="item.Value"
          [id]="item.Value + '_checkingAccountStatus_' + count"
          [name]="'checkingAccountStatus_' + count"
          [formControl]="getFormControl('CheckingAccountStatus')"
          (change)="onChangeEvent(item.Value, coApplicant)"
        />
        <label
          class="form-check-label"
          [for]="item.Value + '_checkingAccountStatus_' + count"
        >
          {{ item.Text }}
        </label>
      </div>
    </div>
  </div>
  <div
    *ngIf="!controlIsDisabled('CheckingBankName')"
    [ngClass]="['col-12', !split ? 'col-lg-10' : 'col-md-5 col-lg-6']"
  >
    <div class="mb-3">
      <label class="form-label" [for]="'checkingBankName_' + count">
        Checking Bank Name
        <span *ngIf="controlIsRequired('CheckingBankName')" class="color-error"
          >*</span
        >
      </label>
      <input
        class="form-control"
        [id]="'checkingBankName_' + count"
        placeholder="Bank name"
        type="text"
        [formControl]="getFormControl('CheckingBankName')"
        aria-label="Checking bank name"
      />
    </div>
  </div>
</div>
<div *ngIf="!controlIsDisabled('CheckingBankName')" class="row">
  <div class="col">
    <div>
      <label class="form-label">
        Do you have a debit card?
        <span *ngIf="controlIsRequired('HasDebitCard')" class="color-error"
          >*</span
        >
      </label>
    </div>
    <div
      class="form-check-inline mb-3"
      *ngFor="let item of debitCard; index as i"
    >
      <div class="form-check">
        <input
          class="form-check-input"
          type="radio"
          [value]="item.Value"
          [id]="item.Value + '_debitCard_' + count"
          [name]="'debitCard_' + count"
          [formControl]="getFormControl('HasDebitCard')"
        />
        <label
          class="form-check-label"
          [for]="item.Value + '_debitCard_' + count"
        >
          {{ item.Text }}
        </label>
      </div>
    </div>
  </div>
</div>
